import { modals } from "@mantine/modals";
import { OnboardingIntroVideosCarousel } from "./onboarding-intro-videos";

export function useOnboardingIntroVideosModal(closeable = true) {
	const modalId = "onboarding-intro-videos-modal";

	const open = () => {
		modals.open({
			modalId: modalId,
			centered: true,
			withCloseButton: false,
			closeOnEscape: closeable,
			closeOnClickOutside: closeable,
			zIndex: 9999,
			size: "92vw",
			radius: "md",
			padding: 0,
			classNames: {
				content:
					"flex max-w-[1200px] flex-col overflow-hidden h-[min(92vh,980px)]",
				body: "flex min-h-0 flex-1 overflow-hidden p-0",
			},
			children: (
				<OnboardingIntroVideosCarousel closeable={closeable} onClose={close} />
			),
		});
	};

	const close = () => {
		modals.close(modalId);
	};

	return { open, close };
}
